import { useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import FetchModule from '../../Share/Network/FetchModule.js';
import { useLanguage } from '../../../Context/LanguageContext';

import SignUpPWInput from '../../../Component/AccountComponent/SignUpPwInput.js';

import IdentifierPageLogoPath from '../../../image/SearchIdentifierLogo.png';

const PermuteView = forwardRef((props, ref) => {
  const { permuteButtonClick } = props;
  const history = useHistory();
  const { t } = useLanguage();

  const [pwClickCount, setPwClickCount] = useState(0);
  const [confirmClickCount, setConfirmClickCount] = useState(0);
  const [planationText, setPlanationText] = useState(t('findAccount.requiredField'));

  const TopLevelRef = useRef();
  const PwRef = useRef();
  const ConfirmRef = useRef();
  const PwPlanationRef = useRef();
  const ConfirmPlanationRef = useRef();

  useImperativeHandle(ref, () => ({
    setOpacity: () => {
      TopLevelRef.current.style.opacity = 0;
    }
  }));

  // 비밀번호 변경 토큰 유효성 검증 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('identifier/asp/permute/' + sessionStorage.getItem("PermuteToken"), 'POST');

        if (responseData.status !== 200) {
          alert(t('findAccount.invalidAccess'));
          history.push("/");
        }
      }
    )();
  }, [])

  // Input 클릭 카운트 변경시 유효성 표시 갱신 //
  useEffect(() => {
    if (pwClickCount === 0 && confirmClickCount === 0) return;

    if (PwRef.current.getValue() === '' && pwClickCount > 0) PwPlanationRef.current.style.opacity = 1;
    else PwPlanationRef.current.style.opacity = 0;

    if (ConfirmRef.current.getValue() === '' && confirmClickCount > 0) ConfirmPlanationRef.current.style.opacity = 1;
    else ConfirmPlanationRef.current.style.opacity = 0;
  }, [pwClickCount, confirmClickCount])

  // Input 컴포넌트 클릭시 //
  function clickCountFn(className, clickCount) {
    if (className === 'PWInput') setPwClickCount(clickCount);
    else if (className === 'ConfirmInput') setConfirmClickCount(clickCount);
  }

  // 비밀번호 변경 버튼 클릭시 //
  function onClickChangePassword() {
    const password = PwRef.current.getValue();
    const confirmPassword = ConfirmRef.current.getValue();
    let invalidCount = 0;

    if (password === '') {
      PwRef.current.plusClickCount();
      PwRef.current.setDefaultPlaceholder(t('findAccount.newPwErrorPlaceholder'));

      invalidCount += 1;
    }

    if (confirmPassword === '') {
      ConfirmRef.current.plusClickCount();
      ConfirmRef.current.setDefaultPlaceholder(t('findAccount.confirmPwErrorPlaceholder'));

      invalidCount += 1;
    }

    if (password !== confirmPassword) {
      ConfirmRef.current.setValue('');
      ConfirmRef.current.setDefaultPlaceholder(t('findAccount.pwMismatch'));

      invalidCount += 1;
    }

    if (invalidCount > 0) return;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('identifier/asp/permute/' + sessionStorage.getItem("PermuteToken") + '/' + password, 'POST');

        if (responseData.status === 200) permuteButtonClick();
        else alert(t('findAccount.pwChangeFailed'));
      }
    )();
  }

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <TopTitleWrapper onClick={() => history.push('/')}>
        <Logo src={IdentifierPageLogoPath}/>
        <TopTitle>LINKO ZONE</TopTitle>
      </TopTitleWrapper>
      <InfoBox>
        <InfoWrapper>
          <Title>{t('findAccount.changePw')}</Title>
          <InputInfo>{t('findAccount.newPw')}</InputInfo>
          <SignUpPWInput
            ref={PwRef}
            className='PWInput'
            placeholder={t('findAccount.newPwPlaceholder')}
            type='password'
            clickCountFn={clickCountFn} />
          <AccountExplanation ref={PwPlanationRef}>{t('findAccount.requiredField')}</AccountExplanation>
          <InputInfo>{t('findAccount.confirmPw')}</InputInfo>
          <SignUpPWInput
            ref={ConfirmRef}
            className='ConfirmInput'
            placeholder={t('findAccount.confirmPwPlaceholder')}
            type='password'
            clickCountFn={clickCountFn} />
          <AccountExplanation ref={ConfirmPlanationRef}>{planationText}</AccountExplanation>
          <SendingButton onClick={onClickChangePassword}>
            <SendingButtonText>{t('findAccount.changePw')}</SendingButtonText>
          </SendingButton>
        </InfoWrapper>
      </InfoBox>
    </TopLevelWrapper>
  )
})

export default PermuteView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  opacity: 1;
  transition: all 0.5s ease-in-out;
`;

const TopTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  margin-bottom: 40px;

  &:hover {
    cursor: pointer;
  }
`;

const Logo = styled.img`
  width: 78px;
  height: 78px;

  margin-right: 20px;
`;

const TopTitle = styled.p`
  font-family: Poppins-SemiBold;
  font-size: 36px;

  color: #FF8B48;

  margin: 0 0 0 0;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 582px;
  height: 455px;

  border-radius: 50px;
  background-color: #FFFFFF;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 468px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 24px;

  color: #000000;

  margin-top: 0px;
  margin-right: 0px;
  margin-bottom: 38px;
  margin-left: 0px;
`;

const InputInfo = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  margin: 19px 0 0 0;
`;

const AccountExplanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #FF3131;

  margin: 4px 0 0 0;
  opacity: 0;
  transition: all 0.5s ease-in-out;
`;

const SendingButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 468px;
  height: 46px;

  margin-top: 40px;

  background-color: #FF8B48;
  border-radius: 23px;

  transition: all 0.5s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #FF7322;
  }
`;

const SendingButtonText = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #FFFFFF;

  margin: 0 0 0 0;

  &:hover {
    cursor: pointer;
  }
`;
